import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardPodcastListener } from "../../../redux/reducer/dashboardSlice";

const { RangePicker } = DatePicker;

const initialData = [
  { date: "2024-03-01", totalPlay: 10 },
  { date: "2024-03-02", totalPlay: 50 },
  { date: "2024-03-03", totalPlay: 30 },
  { date: "2024-03-04", totalPlay: 70 },
  { date: "2024-03-05", totalPlay: 90 },
];

const LineChartComp = ({ tenantId }) => {
  const [filteredData, setFilteredData] = useState(initialData);
  const [isDateCleared, setIsDateCleared] = useState(false);

  const dispatch = useDispatch();

  const { dashboardPodcastLisnersData } = useSelector((prev) => prev.dashboard);

  useEffect(() => {
    const today = new Date();
    const before15Days = new Date();
    before15Days.setDate(today.getDate() - 15);

    const formatDate = (date) => date.toISOString().split("T")[0];

    const payload = tenantId
      ? {
          from_date: formatDate(before15Days),
          to_date: formatDate(today),
          tenant_id: tenantId,
        }
      : {
          from_date: formatDate(before15Days),
          to_date: formatDate(today),
        };

    dispatch(fetchDashboardPodcastListener(payload));
  }, [dispatch, tenantId]);

  //   const today = new Date();

  //   const before15Days = new Date();
  //   before15Days.setDate(today.getDate() - 15);

  //   const formatDate = (date) => date.toISOString().split("T")[0]; // yyyy-mm-dd
  //   let payload = {}
  //   if(tenantId === null){
  //     isDateCleared ?  payload = {} :
  //     payload = {
  //       from_date: formatDate(before15Days),
  //       to_date: formatDate(today),
  //     }
  //   }
  //   else{
  //     payload = {
  //       from_date: formatDate(before15Days),
  //       to_date: formatDate(today),
  //       tenant_id: tenantId,
  //     }
  //   }

  //   dispatch(fetchDashboardPodcastListener(
  //    payload

  // ));
  // }, [dispatch, tenantId, isDateCleared]);

  // const handleDateChange = (dates) => {
  //   if (!dates || dates.length === 0) {
  //     setFilteredData(initialData); // Reset if no selection
  //     return;
  //   }

  //   const [start, end] = dates.map((date) => date.format("YYYY-MM-DD"));
  //   const newData = initialData.filter(
  //     (item) => item.date >= start && item.date <= end
  //   );
  //   setFilteredData(newData);
  // };

  // const handleDateChange = (dates) => {
  //   // if (!dates || dates.length === 0) return;
  //   if (!dates || dates?.length === 0) {
  //     setIsDateCleared(true);
  //   } else {
  //     setIsDateCleared(false);
  //   }

  //   const [start, end] = dates?.map((date) => date?.format("YYYY/MM/DD")); // Format as per API
  //   let payload = {}
  //   if(tenantId === null){
  //     payload = {
  //       from_date: start,
  //       to_date: end,
  //     }
  //   }else{
  //     payload =

  //     {
  //       from_date: start,
  //       to_date: end,
  //       tenant_id: tenantId,
  //     }
  //   }

  //   dispatch(fetchDashboardPodcastListener(payload));
  // };

  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setIsDateCleared(true); // optional if you still want it for UI state
      const today = new Date();
      const before15Days = new Date();
      before15Days.setDate(today.getDate() - 15);
      const formatDate = (date) => date.toISOString().split("T")[0];

      const payload = tenantId
        ? {
            from_date: formatDate(before15Days),
            to_date: formatDate(today),
            tenant_id: tenantId,
          }
        : {
            from_date: formatDate(before15Days),
            to_date: formatDate(today),
          };

      dispatch(fetchDashboardPodcastListener(payload));
      return;
    }

    // Dates selected
    setIsDateCleared(false);
    const [start, end] = dates.map((date) => date.format("YYYY-MM-DD")); // format as per API

    const payload = tenantId
      ? { from_date: start, to_date: end, tenant_id: tenantId }
      : { from_date: start, to_date: end };

    dispatch(fetchDashboardPodcastListener(payload));
  };

  const chartOptions = {
    chart: {
      id: "line-chart",
      toolbar: { show: false },
      zoom: {
        enabled: false, // Disable zoom
      },
      animations: {
        enabled: false, // Disable animation to stop "flow" effect
      },
    },
    xaxis: {
      type: "datetime",
      categories: Array.isArray(dashboardPodcastLisnersData)
        ? dashboardPodcastLisnersData.map((item) => item.date)
        : [],
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "Total Users Over Time",
      align: "left",
    },
  };

  const chartSeries = [
    {
      name: "Total Users",
      data: Array.isArray(dashboardPodcastLisnersData)
        ? dashboardPodcastLisnersData.map((item) => item.listener_count)
        : [],
    },
  ];

  return (
    <div>
      <RangePicker
        onChange={handleDateChange}
        format="MM-DD-YYYY"
        defaultValue={[dayjs().subtract(15, "day"), dayjs()]}
        // defaultValue={[dayjs().startOf("month"), dayjs()]}
        style={{ marginBottom: 20 }}
      />
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={350}
      />
    </div>
  );
};

export default LineChartComp;
